module.exports = __webpack_public_path__ + "img/testimonialpanel3.0591ce9d.jpg";